import * as actionTypes from "../ActionTypes";

// ✅ Save Video
export const saveVideoRequest = (apiPayloadRequest, callback) => ({
 
  type: actionTypes.SAVE_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveVideoSuccess = (data) => ({
  type: actionTypes.SAVE_VIDEO_SUCCESS,
  payload: data,
});

export const saveVideoFailure = (error) => ({
  type: actionTypes.SAVE_VIDEO_FAILURE,
  payload: error,
});

// ✅ Update Video
export const updateVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_VIDEO_SUCCESS,
  payload: data,
});

export const updateVideoFailure = (error) => ({
  type: actionTypes.UPDATE_VIDEO_FAILURE,
  payload: error,
});

// ✅ Delete Video
export const deleteVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteVideoSuccess = (data) => ({
  type: actionTypes.DELETE_VIDEO_SUCCESS,
  payload: data,
});

export const deleteVideoFailure = (error) => ({
  type: actionTypes.DELETE_VIDEO_FAILURE,
  payload: error,
});

// ✅ Read Video
export const readVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_VIDEO_REQUEST,
  payload,
  callback,
});

export const readVideoSuccess = (data) => ({
  type: actionTypes.READ_VIDEO_SUCCESS,
  payload: data,
});

export const readVideoFailure = (error) => ({
  type: actionTypes.READ_VIDEO_FAILURE,
  payload: error,
});
